// Simple database check without complex imports
import { supabase } from '../lib/supabaseClient'
export const checkDatabaseSetup = async () => {
  try {
    console.log('🔍 Checking database setup...')
    
    // Simple check - try to access a basic Supabase function
    const { data, error } = await fetch('/api/health', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    }).catch(() => {
      // If API doesn't exist, that's fine - we're in development mode
      console.log('📋 Running in development mode - database setup needed')
      return { data: null, error: { message: 'Development mode' } }
    })
    
    if (error) {
      console.log('⚠️ Database setup required. Please run the SQL script from QUICK_FIX.md')
      return false
    }
    
    console.log('✅ Database appears to be set up')
    return true
  } catch (err) {
    console.log('📋 Database check failed - this is normal in development')
    return false
  }
}

// Simple user profile creation
export const createUserProfile = async (userId, userData) => {
  try {
    console.log('👤 Creating user profile...')
    
    // Use statically imported supabase client to avoid mixed import mode warnings
    
    // Try to fetch existing profile from database first
    const { data: existingProfile, error: fetchError } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single()
    
    if (existingProfile && !fetchError) {
      console.log('✅ Found existing profile:', existingProfile)
      return existingProfile
    }
    
    // If no existing profile, create a new one
    const { data: newProfile, error: insertError } = await supabase
      .from('profiles')
      .insert({
        id: userId,
        email: userData.email,
        name: userData.name || userData.email?.split('@')[0],
        role: userData.role || 'client',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })
      .select()
      .single()
    
    if (insertError) {
      console.warn('❌ Profile creation failed:', insertError)
      // Return fallback profile
      return {
        id: userId,
        email: userData.email,
        name: userData.name || userData.email?.split('@')[0],
        role: userData.role || 'client'
      }
    }
    
    console.log('✅ User profile created in database:', newProfile)
    return newProfile
  } catch (err) {
    console.warn('Profile creation failed:', err)
    return {
      id: userId,
      email: userData.email,
      name: userData.name || userData.email?.split('@')[0],
      role: userData.role || 'client'
    }
  }
}
